import { Injectable } from '@angular/core';
import { createAction, props } from '@ngrx/store';

@Injectable({
    providedIn: 'root' // No need to provide in AppModule, and now tree shakable
})
export class Ar2UserActions {
    static getTemplatesAndNotificationOffsets = createAction('[Autoremind] Get Templates and NotificationOffsets for AR2 user');

    static getTemplatesAndNotificationOffsetsSuccess = createAction('[Autoremind] Get Templates and NotificationOffsets Success for AR2 user',
        props<{ payload: any }>());

    static getTemplatesAndNotificationOffsetsFail = createAction('[Autoremind] Get Templates and NotificationOffsets Fail for AR2 user',
        props<{ error: any }>());
}
